'use client';
import { createClient } from '@/lib/supabase/client';

const supabase = createClient();

function getSessionId(): string {
  if (typeof window === 'undefined') return 'ssr';
  let sid = sessionStorage.getItem('aidaram_sid');
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('aidaram_sid', sid);
  }
  return sid;
}

export type EventType =
  | 'homepage_visit' |'airdrop_click' |'airdrop_join' |'signup' |'email_open' |'email_click' |'market_dashboard_visit' |'page_view';

export async function logEvent(
  eventType: EventType,
  metadata: Record<string, unknown> = {},
  userId?: string
) {
  try {
    await supabase.from('event_logs').insert({
      event_type: eventType,
      user_id: userId || null,
      session_id: getSessionId(),
      metadata,
    });
  } catch {
    // silently fail — never block UI for analytics
  }
}

export async function triggerAutomatedEmail(payload: {
  trigger_type: 'signup' | 'airdrop_join';
  user_id?: string;
  email: string;
  full_name?: string;
  airdrop_name?: string;
}) {
  try {
    const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
    const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
    if (!supabaseUrl || !supabaseAnonKey) return;

    await fetch(`${supabaseUrl}/functions/v1/send-email-campaign`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${supabaseAnonKey}`,
      },
      body: JSON.stringify(payload),
    });
  } catch {
    // silently fail — email is non-blocking
  }
}
